import { skipToken } from "@reduxjs/toolkit/query";
import { createContext } from "react";
import { useParams } from "react-router-dom";
import { useGetWaitingRoomPatientQuery } from "src/api/services/tasksApi";
import { WaitingRoomPatient } from "src/api/types";
import Spinner from "src/components/Spinner";
import { MatchParam } from "src/constants/matches";

export const WaitingRoomContext = createContext<WaitingRoomPatient | undefined>(
  undefined
);

interface Props {
  children: React.ReactNode;
}

const WaitingRoomProvider = ({ children }: Props) => {
  const { waitRoomId } = useParams<MatchParam<"WAIT_ROOM_ID">>();
  const { data, isLoading } = useGetWaitingRoomPatientQuery(
    waitRoomId ? Number(waitRoomId) : skipToken
  );

  if (isLoading) return <Spinner />;

  return (
    <WaitingRoomContext.Provider value={data}>
      {children}
    </WaitingRoomContext.Provider>
  );
};

export default WaitingRoomProvider;
